"use client";
import { useEffect } from "react";

export default function Loader() {
  useEffect(() => {
    const loader = document.getElementById("loader");
    if (loader) {
      loader.style.opacity = 1;
      setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        loader.style.display = "none";
      }, 500);
    }
  }, []);

  return null;
}